import {
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  ButtonGroup,
  BasicButton,
  DangerButton,
} from "@certn/cascadia-react";
import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";

import { Schemas } from "../../../../types";

type UserRemoveModalProps = {
  handleClose: () => void;
  user?: Schemas["CustomerAccountUsersListCompact"];
  groupName?: string;
  handleRemoveUser: () => void;
};

export function UserRemoveModal(props: UserRemoveModalProps) {
  const { handleClose, user, groupName, handleRemoveUser } = props;
  return (
    <Modal isOpen>
      <Dialog>
        <DialogHeader onClose={handleClose}>
          {`${t("Remove")} ${user?.auth0_full_name}`}
        </DialogHeader>
        <DialogContent>
          {t(
            `By clicking "Remove member", {{name}} will be removed from {{groupName}}, and their group access will be revoked.`,
            { name: user?.auth0_full_name, groupName }
          )}
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <BasicButton size="medium" onPress={handleClose}>
              <Trans>Cancel</Trans>
            </BasicButton>
            <DangerButton size="medium" onPress={handleRemoveUser}>
              <Trans>Remove member</Trans>
            </DangerButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
